export enum actionTypes {
    REDUX_BUTTON_CHANGE_TEXT = 'REDUX_BUTTON:TEXT:CHANGE'
}
